angular.module('homebot.directives')

.directive('cmaRequest', [function(){
  return {
    restrict: 'A',
    controllerAs: 'cmaRequestCtrl',
    bindToController: {
      agent: '=',
      previousRea: '=',
      requestCma: '&onRequestCma',
      skipCmaRequest: '&onSkipCmaRequest',
      nextQuestion: '&onNextQuestion'
    },
    scope: {},
    templateUrl: (el, attrs) => attrs.templateUrl,
    controller: function(){ }
  }

}]);
